import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { Config, ConfigService } from '@empathyco/playboard-core-domain'
import type { ComputedRef } from 'vue'
import { computed, getCurrentInstance, ref, watch } from 'vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import { CONFIG_CONSTS } from '../../store/config/config.consts'
import { mapGetters } from '../utils'

export interface SemanticsComposable {
  enabled: ComputedRef<boolean | undefined>
}

const serviceConfig = ref<Pick<Config, 'instance' | 'enabled'> | undefined>(undefined)

async function initServiceConfig(instance: string): Promise<void> {
  if (serviceConfig.value?.instance !== instance) {
    const configService = CONTAINER.get<ConfigService>(TYPES.ConfigService)
    const defaultServiceConfig: typeof serviceConfig.value = { instance, enabled: false }
    if (configService) {
      try {
        serviceConfig.value = await configService.read({
          instance,
          service: 'semantics',
        })
      } catch (error) {
        serviceConfig.value = defaultServiceConfig
      }
    } else {
      serviceConfig.value = defaultServiceConfig
    }
  }
}

export function useSemantics(): SemanticsComposable {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }

  const { instanceConfig } = mapGetters<Instance>(ctx.proxy.$store, CONFIG_CONSTS.moduleName, {
    instanceConfig: CONFIG_CONSTS.getters.currentInstance,
  })

  const enabled = computed<boolean | undefined>(() => serviceConfig.value?.enabled)

  watch(() => instanceConfig.value.id, initServiceConfig, { immediate: true })

  return {
    enabled,
  }
}
